import { Divider, Flex, Typography } from 'antd';
import { Children, type ReactNode } from 'react';

export interface TimelineSection {
  key: string;
  /** Pre-computed heading, e.g. "Today" / "2 days ago" / "3 weeks ago". */
  label: ReactNode;
  /** TimelineItem elements for this section. */
  children: ReactNode;
}

export interface TimelineProps {
  sections: TimelineSection[];
  emptyState?: ReactNode;
  className?: string;
}

export const Timeline = ({
  sections,
  emptyState,
  className,
}: TimelineProps) => {
  const nonEmptySections = sections.filter(
    (section) => Children.toArray(section.children).length > 0,
  );

  if (nonEmptySections.length === 0) {
    return emptyState ? (
      <Flex align="center" justify="center" className={className}>
        {emptyState}
      </Flex>
    ) : null;
  }

  return (
    <Flex vertical className={className}>
      {nonEmptySections.map((section) => (
        <Flex vertical key={section.key}>
          <Divider plain>
            <Typography.Text
              type="secondary"
              style={{ textTransform: 'uppercase', fontSize: 12 }}
            >
              {section.label}
            </Typography.Text>
          </Divider>
          <Flex vertical gap={12}>
            {section.children}
          </Flex>
        </Flex>
      ))}
    </Flex>
  );
};

export default Timeline;
